import axios from 'axios';

// 从环境变量获取API基础URL
const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;

// 创建专用于认证的axios实例
const authClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000
});

// 本地存储令牌的键名
const TOKEN_KEY = 'hajimi_auth_token';

export default {
  // 登录方法
  async login(username, password) {
    try {
      const response = await authClient.post('/auth/login', {
        username,
        password
      });
      
      // 检查响应
      if (response.data && response.data.code === 200 && response.data.data?.token) {
        // 保存令牌到localStorage
        localStorage.setItem(TOKEN_KEY, response.data.data.token);
        return true;
      }
      return false;
    } catch (error) {
      console.error('登录失败:', error);
      throw error;
    }
  },

  // 注销方法
  logout() {
    localStorage.removeItem(TOKEN_KEY);
  },

  // 获取当前令牌
  getToken() {
    return localStorage.getItem(TOKEN_KEY);
  },

  // 检查是否已认证
  isAuthenticated() {
    return !!this.getToken();
  },

  // 添加认证拦截器，为请求添加Authorization头
  setupInterceptors(axiosInstance) {
    axiosInstance.interceptors.request.use(
      config => {
        const token = this.getToken();
        if (token) {
          config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
      },
      error => {
        return Promise.reject(error);
      }
    );

    // 处理401错误的响应拦截器
    axiosInstance.interceptors.response.use(
      response => response,
      error => {
        if (error.response && error.response.status === 401) {
          // 令牌无效或过期，清除本地存储
          this.logout();
          // 可以在这里添加重定向到登录页面的逻辑
        }
        return Promise.reject(error);
      }
    );
  }
};